/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessCodeSeriesRef } from "./AccessCodeSeriesRef";
import type { AccessCodeString } from "./AccessCodeString";
export type ConnectAccessCodeSeriesOutcome = {
  kind: ConnectAccessCodeSeriesOutcome.kind;
} | {
  data: {
    duplicate_codes: Array<AccessCodeString>;
  };
  kind: ConnectAccessCodeSeriesOutcome.kind;
} | {
  data: {
    composite_series: Array<AccessCodeSeriesRef>;
  };
  kind: ConnectAccessCodeSeriesOutcome.kind;
};
export namespace ConnectAccessCodeSeriesOutcome {
  export enum kind {
    OK = "ok",
  }
}
